export default __webpack_public_path__ + "static/media/warning.ad0fa4e1.svg";